import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  table: {
    backgroundColor: 'white',
    '& tbody tr:nth-child(odd)': {
      backgroundColor: '#fcfcfc',
    },
  },
}

const Table = ({ classes, children, className }) => (
  <table className={classNames(classes.table, className)}>{children}</table>
)

export default injectStyles(styles)(Table)
